import { render, staticRenderFns } from "./ProductTiersApplyAll.vue?vue&type=template&id=1dd5c3e7&scoped=true&lang=pug&"
import script from "./ProductTiersApplyAll.vue?vue&type=script&lang=js&"
export * from "./ProductTiersApplyAll.vue?vue&type=script&lang=js&"
import style0 from "./ProductTiersApplyAll.vue?vue&type=style&index=0&id=1dd5c3e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5c3e7",
  null
  
)

/* custom blocks */
import block0 from "./ProductTiersApplyAll.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VTextField})
